module.exports = __webpack_public_path__ + "static/media/bg-greetings.802eda16.jpg";